<div class="rfid-card-scan-container">
  <h1>{{'Please insert a RFID card' | translate }}</h1>
  <app-insert-card-image></app-insert-card-image>
</div>
